import { useLanguage } from "@/i18n/LanguageContext";
import { Shield, Lock, Users, Layers, Database, Network } from "lucide-react";

const items = [
  { i: Shield, t: "Customer data ownership", d: "The customer owns the collected production data. Data is used for operating BEEDIGIT and supporting the customer." },
  { i: Lock, t: "Secure communication", d: "Encrypted communication between users, devices and BEEDIGIT platform." },
  { i: Users, t: "Role-based access", d: "Different access for operators, supervisors, maintenance, quality, managers, administrators and enterprise users." },
  { i: Layers, t: "Multi-tenant architecture", d: "Customer data is logically separated and managed securely." },
  { i: Database, t: "Backups and reliability", d: "Production database backup and replication procedures support business continuity." },
  { i: Network, t: "ERP / IT friendly", d: "BEEDIGIT works with IT and OT teams to define secure integration methods." },
];

export default function SecurityEnterprise() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Security & enterprise readiness")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Enterprise-ready security and data ownership.")}</h2>
          <p className="text-muted-foreground">
            {t("BEEDIGIT is built for serious manufacturing environments where production data, uptime and access control matter.")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div key={it.t} className="rounded-lg border border-border bg-card p-5">
              <it.i className="h-6 w-6 text-primary mb-3" />
              <h3 className="font-semibold mb-2">{t(it.t)}</h3>
              <p className="text-sm text-muted-foreground">{t(it.d)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}